module.exports = __webpack_public_path__ + "img/xun-you.f521011f.jpeg";